<app-number-filter [filter]="filter" [suffix]="' q.ty'" [dataToView]="dataToView">
</app-number-filter>
